import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import __LocalStorage from '../../utils/localData';
import { LoginParams } from '../../interface/auth';
import { ApiService } from '../../utils/apiService';

interface UserInfo {
  id: string;
  email: string;
  password: string;
  role: number;
}
export interface AuthState {
  accessToken?: string | null;
  userInfo: UserInfo | null;
  loading: boolean;
  error: string;
  userType?: 'administrator' | 'customer';
  authUser?: any;
}
const initialState: AuthState = {
  accessToken: __LocalStorage('accessToken') || null,
  userInfo: null,
  loading: false,
  error: '',
};
export const login = createAsyncThunk('/admin-api/auth/login', async (payload: LoginParams, thunkAPI) => {
  try {
    const response = await ApiService<{ accessToken: string; admin: UserInfo }>(
      '/admin-api/auth/login',
      'POST',
      payload,
    );
    if (response.statusCode !== 200) {
      return thunkAPI.rejectWithValue({
        code: response.statusCode,
        error: response.error || 'Login failed',
      });
    }
    if (response.data?.accessToken) {
      const jsonUserInfo = JSON.stringify(response.data.admin);
      __LocalStorage('user_info', jsonUserInfo);
      __LocalStorage('accessToken', response.data.accessToken, false);
    }

    return {
      method: 'POST',
      code: response.statusCode,
      data: response.data,
      message: response.message,
    };
  } catch (error: any) {
    return thunkAPI.rejectWithValue({
      code: error.response?.status || 500,
      error: error.message || 'Error',
    });
  }
});
export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state.accessToken = null;
      __LocalStorage('accessToken', null, true);
      __LocalStorage('user_info', null, true);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, () => {})
      .addCase(login.fulfilled, (state, action) => {
        state.accessToken = action?.payload?.data?.accessToken;
        state.userInfo = action?.payload?.data?.admin as UserInfo;
      })
      .addCase(login.rejected, () => {});
  },
});

export const { logout } = authSlice.actions;
export const selectAuth = (state: RootState) => state.auth;
export default authSlice.reducer;
